import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { enrollmentReducer, EnrollmentState } from './enrollment.reducer';
import { membershipReducer, MembershipState } from './membership.reducer';
import {
  redeemCashLoyaltyProgramReducer,
  RedeemCashLoyaltyProgramState,
} from './redeem-cash-loyalty-program.reducer';

export interface RedeemCashV2State {
  enrollment: EnrollmentState;
  redeemCashLoyaltyPrograms: RedeemCashLoyaltyProgramState;
  membership: MembershipState;
}

export const reducers: ActionReducerMap<RedeemCashV2State> = {
  // @ts-ignore
  enrollment: enrollmentReducer,
  // @ts-ignore
  redeemCashLoyaltyPrograms: redeemCashLoyaltyProgramReducer,
  // @ts-ignore
  membership: membershipReducer,
};

export const getRedeemCashV2State =
  createFeatureSelector<RedeemCashV2State>('redeemCashV2');
